import { JobStore } from '../../store';
import formurlencoded from 'form-urlencoded';

import {
  showNextSurveyQuestion,
  showPreviousSurveyQuestion,
  initializeContext,
  changeTab,
  startTest,
  showResponse,
  showNextResponseScreen,
  updateContext,
  setFinalFeedBackAnswer,
  setRedirectURL,
  setError
} from '../../actions/CandidateTestActions';
import { BASE_URL , CANDIDATE_TEST_API, CANDIDATE_TEST_SUBMIT_API, CANDIDATE_TEST_SUBMIT_HARVARD_ANSWER } from '../../constants';
import FetchHelper from '../FetchHelper';
import Context from '../Context';
import UrlBuilder from '../Search/UrlBuilder';
import root from 'window-or-global';
import { firePageLoadGa } from '../GaHelper';

export default class CandidateTestUtils {
  static showNextSurveyQuestion = () => {
    JobStore.dispatch(showNextSurveyQuestion());
  };

  static showPreviousSurveyQuestion = () => {
    JobStore.dispatch(showPreviousSurveyQuestion());
  };

  static isTabChangeAllowed = (newTab, currentTab) => {
    let isAllowed = true;

    let storeValues = JobStore.getState();
    let candidateTestStore = storeValues.candidateTest;

    if ('survey' === currentTab) {
      isAllowed = (Object.keys(candidateTestStore.surveyAnswers).length === candidateTestStore.surveyQuestionsOverall.length);
    } else if('skillTest' === currentTab) {
      isAllowed = (Object.keys(candidateTestStore.skillTestAnswers).length === candidateTestStore.skillTestQuestions.length);
    }

    return isAllowed;
  };

  static changeTab = (newTab, currentTab) => {
    if (CandidateTestUtils.isTabChangeAllowed(newTab, currentTab)) {
      scrollTo(0, 0);
      CandidateTestUtils.performTrackingActions({ action: 'tabChange', newTab });
      JobStore.dispatch(changeTab(newTab));
    } else {
      JobStore.dispatch(setError('Please answer all the questions in the current section before moving on to the next one'));

      //hack to make sure the message is thrown again when required
      setTimeout(() => {
        JobStore.dispatch(setError(''));
      }, 5000);
    }
  };

  static initializeContext = (applicationId, token) => {
    let fetchHelper = new FetchHelper();

    let url = BASE_URL + CANDIDATE_TEST_API.replace('{applicationId}', applicationId).replace('{token}', token);

    let options = {
      url
    };
    let contextPromise = fetchHelper.request('GET', options);
    contextPromise.then(apiResponse => {
      if (apiResponse.hasOwnProperty('data')) {
        let response = apiResponse.data;
        if (response.success) {
          let newContext = response.json;

          let surveyQuestionsOverall = response.json.surveyQuestionsOverall;
          let surveyConfidenceQuestionMap = {};
          let surveyQuestions = [];
          for (let index in surveyQuestionsOverall) {
            if (surveyQuestionsOverall.hasOwnProperty(index)) {
              let question = surveyQuestionsOverall[index];
              let label = question.label;
              //Ignoring confidence questions
              if (label.indexOf('Confidence - ') === -1) {
                surveyQuestions.push(question);
              } else {
                //creating confidence question map for easier rendering
                let regex = /Confidence - Candidate Test Survey Q(.*)/;
                let matches = regex.exec(label);
                if (matches.hasOwnProperty(1)) {
                  let mainQuestionNumber = matches[1];
                  if (surveyQuestions.hasOwnProperty(mainQuestionNumber - 1)) {
                    let mainQuestion = surveyQuestions[mainQuestionNumber - 1];
                    let mainQuestionId = mainQuestion.id;
                    surveyConfidenceQuestionMap[mainQuestionId] = question;
                  }
                }
              }
            }
          }
          newContext.surveyQuestionsOverall = surveyQuestionsOverall;
          newContext.surveyQuestions = surveyQuestions;
          newContext.surveyConfidenceQuestionMap = surveyConfidenceQuestionMap;

          if (response.json.hasOwnProperty('finalFeedbackQuestion')) {
            newContext.finalFeedbackQuestion = response.json.finalFeedbackQuestion;
          }

          if (newContext.city && newContext.role) {
            let urlBuilder = new UrlBuilder();
            CandidateTestUtils.setRedirectURL(urlBuilder.getJobsSnbUrl({ city: newContext.city, role: newContext.role }));
          }

          if (newContext.isTestTaken) {
            newContext.message = 'Test already Taken!';
          }

          let updatedContext = Object.assign({}, newContext, { isContextLoaded: true });
          JobStore.dispatch(initializeContext(updatedContext));
          Context.hideLoader();

          if (!newContext.isTestTaken) {
            //calling ajax here because it depends on the above ajax response.
            CandidateTestUtils.performTrackingActions( { action: 'initiate'});
          }
        }
      }
    });
  };

  static submitCandidateTest = payload => {
    Context.showLoader();
    let fetchHelper = new FetchHelper();
    let url = BASE_URL + CANDIDATE_TEST_SUBMIT_API;

    let options = {
      url,
      data: formurlencoded(payload)
    };

    let submitResponse = fetchHelper.request('POST', options);
    submitResponse.then(apiResponse => {
      if (apiResponse.hasOwnProperty('data')) {
        let response = apiResponse.data;
        if (response.success) {
          let testResponse = response.json;
          scrollTo(0, 0);
          JobStore.dispatch(showResponse({
            testResponse,
            isTestSubmitted: true
          }));

          CandidateTestUtils.performTrackingActions({ action: 'showResponse' });
        }
      }
      Context.hideLoader();
    });
  };

  static startTest = () => {
    scrollTo(0, 0);
    JobStore.dispatch(startTest());
  };

  static showNextResponseScreen = () => {
    scrollTo(0, 0);
    JobStore.dispatch(showNextResponseScreen());
  };

  static setURL = (url) => {
    JobStore.dispatch(updateContext({ url }));
  };

  static setRedirectURL = (redirectUrl) => {
    if (redirectUrl) {
      JobStore.dispatch(setRedirectURL(redirectUrl));
    }
  };

  static redirect = () => {
    Context.showLoader();
    let store = JobStore.getState();
    let candidateTestStore = store.candidateTest;
    let redirectURL = candidateTestStore.redirectURL;
    if (redirectURL) {
      root.location.href = redirectURL;
    }
  };

  static setFinalFeedbackAnswer = (answerObject) => {
    JobStore.dispatch(setFinalFeedBackAnswer(answerObject));
  };

  static submitFinalFeedbackAnswer = (payload) => {
    Context.showLoader();
    let contextPromise = CandidateTestUtils.submitHarvardAnswer(payload);
    contextPromise.then(apiResponse => {
      if (apiResponse.hasOwnProperty('data')) {
        let response = apiResponse.data;
        if (response.success) {
          CandidateTestUtils.redirect();
        }
      }
    });
  };

  static submitHarvardAnswer = payload => {
    let fetchHelper = new FetchHelper();

    let url = BASE_URL + CANDIDATE_TEST_SUBMIT_HARVARD_ANSWER;

    let options = {
      url,
      data: formurlencoded(payload)
    };
    return fetchHelper.request('POST', options);
  };

  static performTrackingActions(params) {
    firePageLoadGa('candidateTest', params);
    CandidateTestUtils.trackAction(params);
  }

  static fireGAOnClose() {
    let storeValues = JobStore.getState();
    let candidateTestStore = storeValues.candidateTest;
    let currentTab = candidateTestStore.currentTab;

    CandidateTestUtils.performTrackingActions( { action: 'close', tab: currentTab } );
  }

  static trackAction (params) {

    const requiredActions = [
      'initiate',
      'startTest',
      'close',
      'submitSurvey',
      'submitSkillTest',
      'submitFeedback',
      'answerFeedback',
      'responseNext',
      'showResponse'
    ];

    if (params.action && (-1 !== requiredActions.indexOf(params.action))) {
      let storeValues = JobStore.getState();
      let candidateTestStore = storeValues.candidateTest;
      const userId = candidateTestStore.userId;
      const applicationId = candidateTestStore.applicationId;
      const actionTrackingQuestionId = candidateTestStore.actionTrackingQuestionId;

      if (actionTrackingQuestionId) {
        let payload = {
          userId: userId,
          questionId: actionTrackingQuestionId,
          answerId: 0,
          answer: (new Date()).getTime(),
          extraData: JSON.stringify(Object.assign({}, params, { applicationId })),
          overrideRequired: true
        };

        CandidateTestUtils.submitHarvardAnswer(payload);
      }
    }
  }
}



// WEBPACK FOOTER //
// ../q-jobs/src/utils/CandidateTest/index.js